import React from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import './StudentLayout.css';

const StudentLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, signOut } = useUser();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
      // Navigate anyway
      navigate('/');
    }
  };

  return (
    <div className="student-layout">
      <div className="student-header">
        <div className="header-content">
          <h1>🎒 Student Portal</h1>
          <p>Welcome, {user?.name}!</p>
        </div>
        <button className="signout-btn" onClick={handleSignOut}>
          🚪 Sign Out
        </button>
      </div>
      <nav className="student-nav">
        <Link
          to="/student/registered"
          className={`nav-link ${location.pathname === '/student/registered' || location.pathname === '/student/sessions' ? 'active' : ''}`}
        >
          📚 Sessions Registered
        </Link>
        <Link
          to="/student/available"
          className={`nav-link ${location.pathname === '/student/available' ? 'active' : ''}`}
        >
          📅 Available Sessions
        </Link>
        <Link
          to="/student/settings"
          className={`nav-link ${location.pathname === '/student/settings' ? 'active' : ''}`}
        >
          ⚙️ Settings
        </Link>
      </nav>
      <div className="student-content">
        {children}
      </div>
    </div>
  );
};

export default StudentLayout;

